import { render, staticRenderFns } from "./PreviewEvent.vue?vue&type=template&id=4c6a61ac"
import script from "./PreviewEvent.vue?vue&type=script&lang=js"
export * from "./PreviewEvent.vue?vue&type=script&lang=js"
import style0 from "./PreviewEvent.vue?vue&type=style&index=0&id=4c6a61ac&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports